import {
  GridPresetOneHalf,
  GridPresetTwoThirds,
  GridRow,
  OptimizelyEditProperty,
  WebcruiterLinkItem,
} from "/App.Components";
import { WebcruiterRssFeedBlockProps } from "/Models/Generated/WebcruiterRssFeedBlockProps";
import "./WebcruiterRssFeedBlock.scss";
import { RowSpacing } from "../../Layout/GridRow/GridRow";

const WebcruiterRssFeedBlock = ({
  heading,
  headingPropertyName,
  links,
  openExternalLinkAriaLabel,
}: WebcruiterRssFeedBlockProps) => {
  const length = links?.length ?? 0;
  const firstCol = (links ?? []).slice(0, Math.ceil(length / 2));
  const lastCol = (length > 1 ? (links ?? []) : []).slice(
    -Math.floor(length / 2),
  );

  return (
    <div className="webcruiter-rss-feed-block">
      <OptimizelyEditProperty propertyName={headingPropertyName}>
        {heading && (
          <h2 className="webcruiter-rss-feed-block__heading">{heading}</h2>
        )}
      </OptimizelyEditProperty>
      {(links?.length ?? 0) > 0 && (
        <GridRow rowSpacing={RowSpacing.s}>
          {firstCol.length === 1 && lastCol.length === 0 && (
            <GridPresetTwoThirds>
              <WebcruiterLinkItem {...firstCol[0]} />
            </GridPresetTwoThirds>
          )}
          {lastCol.length > 0 && (
            <>
              <GridPresetOneHalf>
                <ul className="webcruiter-rss-feed-block__list">
                  {firstCol.map((link, idx) => (
                    <li
                      key={idx}
                      className="webcruiter-rss-feed-block__list-item"
                    >
                      <WebcruiterLinkItem
                        {...link}
                        externalLinkAriaLabel={openExternalLinkAriaLabel}
                      />
                    </li>
                  ))}
                </ul>
              </GridPresetOneHalf>
              <GridPresetOneHalf>
                <ul className="webcruiter-rss-feed-block__list">
                  {lastCol.map((link, idx) => (
                    <li
                      key={idx}
                      className="webcruiter-rss-feed-block__list-item"
                    >
                      <WebcruiterLinkItem
                        {...link}
                        externalLinkAriaLabel={openExternalLinkAriaLabel}
                      />
                    </li>
                  ))}
                </ul>
              </GridPresetOneHalf>
            </>
          )}
        </GridRow>
      )}
    </div>
  );
};

export default WebcruiterRssFeedBlock;
